import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import CancelPaymentForm from 'src/components/Forms/CancelsPaymentForm';

const CancelPaymentDialog = () => {
  const opened =
    useSelector((state: Store) => state.dialog[DIALOGS.cancelPayments]?.opened || false);

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="cancel-payment"
      open={opened}>
      <DialogTitle id="cancel-payment">{t(lang, 'forms.payments.cancel_payment')}</DialogTitle>
      <DialogContent dividers>
        <CancelPaymentForm />
      </DialogContent>
    </Dialog>
  );
};

export default CancelPaymentDialog;
